<template>
    <div id="bene-payment-purpose-container">
        <f7-list form class="form-group">
            <f7-list-input
                input-id     ="paymentPurpose"
                id           ="paymentPurposeInput"
                name         ="paymentPurpose"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.contact.paymentPurpose"
                :label       ="$t('beneficiary-payment-purpose')"
                :placeholder ="$t('beneficiary-select-payment-purpose')"
                :value       ="paymentPurpose"
                @change      ="setPaymentPurpose($event.target.value); validateInput($event.target); setInput('paymentPurpose')"

                autocomplete ="off"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-tx-purpose" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownPaymentPurpose" class="popover-dropdown-tx-purpose dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in paymentPurposeList"
                    :key="item.key"
                    selected=""
                    @click="changePaymentPurpose(item.key); validateInput($event.target); setInput('paymentPurpose')">
                    {{item.value}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="paymentPurposeOther"
                name         ="paymentPurposeOther"
                type         ="text"

                v-if         ="showFormInput.contact.paymentPurposeOther"
                :label       ="$t('beneficiary-other-payment-purpose')"
                :placeholder ="$t('beneficiary-other-payment-purpose')"
                :value       ="paymentPurposeOther"
                @change      ="setPaymentPurposeOther($event.target.value); validateInput($event.target); setInput('paymentPurposeOther')"

                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            // console.log("paymentPurposeList: ", this.paymentPurposeList)
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'paymentPurpose',
                'paymentPurposeList',
                'paymentPurposeOther',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setPaymentPurpose',
                'setPaymentPurposeOther',
            ]),

            async init(){
                const popover = ".beneficiary.popover-dropdown-tx-purpose";
                const popoverInner = ".beneficiary.popover-dropdown-tx-purpose .popover-inner";
                const popoverId = "dropdownPaymentPurpose";
                const inputId = "paymentPurpose";
                const inputListId = "#paymentPurposeInput";
                await this.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
            },

            changePaymentPurpose(id){
                this.$emit("changePaymentPurpose", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>